"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Close = exports.Alert = void 0;

require("./styles.css");

var Alert = {
  name: 'Alert',
  props: {
    id: [String, Number],
    title: [String, Object],
    close: Function,
    clear: Function,
    reset: Function
  },
  render: function render(h) {
    return h('span', {
      class: ['Breadstick__alert'],
      attrs: {
        id: this.id
      },
      on: {
        mouseenter: this.clear,
        mouseleave: this.reset
      }
    }, [typeof title === 'string' ? h('div', {
      class: ['Breadstick__alert_text']
    }, this.title) : this.title, !this.title && this.$slots.default, this.close && h(Close, {
      props: {
        close: this.close
      }
    })]);
  }
};
exports.Alert = Alert;
var Close = {
  name: 'Close',
  props: {
    close: {
      type: Function,
      default: function _default() {
        return null;
      }
    }
  },
  render: function render(h) {
    return h('button', {
      class: ['Breadstick__alert_close'],
      attrs: {
        type: 'button',
        'aria-label': this.close
      },
      on: {
        click: this.close
      }
    }, [h('span', {
      attrs: {
        'aria-hidden': true
      }
    }, '×')]);
  }
};
exports.Close = Close;